import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { restore_slashes } from "../background_functions";
import ContextProviderElementFunctions from "../Contexts/ContectProviderElementFunctions";
import { UploadFile } from "../ElementFunctions/UploadFile/UploadFile";
import { AddFolder } from "../ElementFunctions/AddFolder/AddFolder";

import { I_breadcrumb } from "../Contexts/ContextViewFileList";
import { FileWithPath } from "react-dropzone";

interface NavigationBarProps {
  breadcrumbs: I_breadcrumb[];
  currDirId: string | undefined;
  currDirView: any;
  userSpecific: boolean;
  navigateUp: () => void;
  onUploadStart?: (files: FileWithPath[]) => void;
  onUploadSuccess?: (files: FileWithPath[]) => void;
  onUploadError?: (files: FileWithPath[]) => void;
}

export const NavigationBar: React.FC<NavigationBarProps> = ({
  breadcrumbs,
  currDirId,
  currDirView,
  userSpecific,
  navigateUp,
  onUploadStart,
  onUploadSuccess,
  onUploadError,
}) => {
  if (breadcrumbs.length === 0) return null;

  // Use the current folder name from the breadcrumbs (derived from the URL)
  // instead of currDirView.parent. While the new folder's contents are still
  // loading, curr_dir_view holds the *previous* directory, so its `parent`
  // would briefly show the old name (e.g. "root") even though the breadcrumb
  // already shows the target folder. The last breadcrumb is derived
  // synchronously from the URL and is always in sync with the breadcrumb bar.
  const currentFolderName = breadcrumbs[breadcrumbs.length - 1]?.name ?? "";

  return (
    <Box sx={{ display: "flex"}}>
      <IconButton onClick={navigateUp} title={"Zurück"}>
        <ArrowBack />
      </IconButton>
      
      {currentFolderName && (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ flex: 1 }} />
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {restore_slashes(currentFolderName)}
          </Typography>
          <Box sx={{ flex: 1 }} />
        </Box>
      )}
      
      <Box sx={{ flex: 1 }} />
      
      {currDirId !== undefined &&
        currDirView &&
        "parent" in currDirView && 
        userSpecific === false && (
          <Box>
            <ContextProviderElementFunctions
              key={"ContextProviderElementFunctions_" + currDirId}
              curr_dir_id={currDirId}
              type={"dir"}
              name={restore_slashes(currDirView.parent)}
            >
              <UploadFile
                onUploadStart={onUploadStart}
                onUploadSuccess={onUploadSuccess}
                onUploadError={onUploadError}
              />
              <AddFolder />
            </ContextProviderElementFunctions>
          </Box>
        )}
    </Box>
  );
};